module.exports = __webpack_public_path__ + "static/media/image_xiao_logo1.b3fd0b60.png";